<template>
  <!-- Nothing to choose from, or the scope/range does not allow it: show the zone as text. -->
  <span
    v-if="options.length <= 1 || !available"
    v-tooltip="textTooltip"
    class="d-flex align-items-center h-40"
  >
    {{ showDescription ? active.description : active.abbr }}
  </span>
  <AppTimeZoneDropdown
    v-else
    :active="active"
    :options="options"
    :tooltip-options="tooltipOptions"
    :direction="direction"
    :disabled="disabled"
    :trigger-classes="triggerClasses"
    :show-description="showDescription"
    @input="changeTimeZone"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import AppTimeZoneDropdown from '~/components/AppTimeZoneDropdown.vue';

export default {
  name: 'InsightsHeaderTimeZoneFilter',
  components: { AppTimeZoneDropdown },
  props: {
    direction: {
      type: String,
      default: 'left',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    triggerClasses: {
      type: String,
      default: '',
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
    available: {
      type: Boolean,
      default: true,
    },
  },
  // Must be declared: without it the parent's @input listener falls through via $attrs onto the
  // root element, where bubbling native input events would invoke it with a DOM Event.
  emits: ['input'],
  data: () => ({
    tooltipOptions: Object.freeze({ container: 'body' }),
  }),
  computed: {
    ...mapGetters({ active: 'activeTimeZone', options: 'timeZoneOptions' }),
    title() {
      return this.active.offset ? `${this.active.display_name} (${this.active.offset})` : this.active.display_name;
    },
    // The title goes through the directive, which updates an open tooltip in place on a zone change.
    textTooltip() {
      return { ...this.tooltipOptions, title: this.title };
    },
  },
  methods: {
    changeTimeZone(tzParam, _description, mode) {
      this.$emit('input', tzParam, mode);
    },
  },
};
</script>
